module.exports = __webpack_public_path__ + "vk.svg?491132d03813dd5f0bbe626b9afafb2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vk.svg
// module id = 74
// module chunks = 0